module.exports = __webpack_public_path__ + "img/ROCKET.9a491a36.svg";